import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfService from './TermsOfService';
import WhatsNew from './WhatsNew';
import LiveScoreView from './LiveScoreView';
import LiveOverlayView from './LiveOverlayView';
import reportWebVitals from './reportWebVitals';

// index.html ships homepage defaults for the canonical link and og:url. Since
// this SPA serves the same HTML on every route, correct them to the current
// path so sub-pages (/privacy, /terms, /whats-new) self-canonicalize instead
// of pointing search engines back at the homepage.
(() => {
  const path = window.location.pathname;
  const url = 'https://advancedbowlingtracker.com' + (path === '/' ? '/' : path);
  document.querySelector('link[rel="canonical"]')?.setAttribute('href', url);
  document.querySelector('meta[property="og:url"]')?.setAttribute('content', url);
})();

function Router() {
  const path = window.location.pathname;
  if (path === '/privacy') return <PrivacyPolicy />;
  if (path === '/terms') return <TermsOfService />;
  if (path === '/whats-new') return <WhatsNew />;
  if (path.startsWith('/live/')) {
    // Live codes are generated from an uppercase charset; normalize so a
    // hand-typed lowercase code still resolves to the right Firestore doc.
    const liveCode = path.split('/live/')[1]?.replace(/\/$/, '')?.toUpperCase();
    if (liveCode) return <LiveScoreView liveCode={liveCode} />;
  }
  if (path.startsWith('/overlay/')) {
    // Transparent OBS browser-source overlay. Slugs are lowercase alphanumerics.
    const slug = path.split('/overlay/')[1]?.replace(/\/$/, '')?.toLowerCase();
    if (slug) return <LiveOverlayView slug={slug} />;
  }
  return <App />;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
